import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CPA_ABANDONADA } from '../../../../config/forms'
import CpaAbandonada from '../../components/consultas/CpaAbandonada'
import * as actions from '../../actions'

class FormCpaAbandonada extends Component {
  constructor (props) {
    super(props)
    this.obtenerDatosCpaAbandonada = this.obtenerDatosCpaAbandonada.bind(this)
  }

  obtenerDatosCpaAbandonada () {
    this.props.obtenerDatosCpaAbandonada()
  }

  render () {
    return (
      <div id='text-cpa-abandonada'>
        <CpaAbandonada
          cpaAbandonada={this.props.cpaAbandonada}
          obtenerDatosCpaAbandonada={this.obtenerDatosCpaAbandonada}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cpaAbandonada: state.camionesIngreso.cpaAbandonada
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(
  reduxForm({ form: FORM_CPA_ABANDONADA })(FormCpaAbandonada)
)
